import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Icon } from "@/lib/ui";
import { Loader2 } from "lucide-react";

const ICONS = {
  TAG_CLAIMED: "ShieldCheck", TAG_MARKED_LOST: "TriangleAlert", TAG_MARKED_FOUND: "CircleCheck",
  FINDER_MESSAGE_RECEIVED: "MessageSquare", TAG_SCANNED: "Radar", OWNERSHIP_TRANSFERRED: "ArrowLeftRight",
};

export default function Activity() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/notifications").then((r) => setItems(r.data.data)).catch(() => setItems([]));
    api.post("/notifications/read-all").catch(() => {});
  }, []);

  return (
    <div className="px-5 pt-8">
      <h1 className="font-display font-black text-3xl tracking-tight">Activity</h1>
      <p className="text-muted-foreground mt-1">Claims, scans and finder messages.</p>

      <div className="mt-6 space-y-3">
        {items === null ? (
          <div className="py-16 grid place-items-center"><Loader2 className="w-6 h-6 animate-spin text-muted-foreground" /></div>
        ) : items.length === 0 ? (
          <div className="py-16 text-center">
            <Icon name="BellOff" className="w-9 h-9 mx-auto text-muted-foreground" />
            <p className="text-sm text-muted-foreground mt-2">Nothing here yet.</p>
          </div>
        ) : items.map((n) => (
          <Link key={n.id} to={n.tag_id ? `/app/tags/${n.tag_id}` : "#"} className="tap flex gap-3 rounded-2xl border border-border p-4 hover:bg-secondary/60" data-testid="activity-item">
            <div className="w-10 h-10 rounded-xl bg-secondary grid place-items-center shrink-0">
              <Icon name={ICONS[n.type] || "Bell"} className="w-5 h-5" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-sm">{n.title}</p>
              <p className="text-sm text-muted-foreground">{n.body}</p>
              <p className="text-xs text-muted-foreground mt-1">{fmt(n.created_at)}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

function fmt(iso) {
  try { return new Date(iso).toLocaleString([], { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }); }
  catch { return iso; }
}
